import { Tooltip, TooltipPosition } from '@tableau/widgets';
import React from 'react';
import { classes, forceRenderStyles } from 'typestyle';

import { showDMAwareness } from '~src/commonInfra/components/DMAwareness/DmAwarenessUtils';

import { Messages } from '../../../codegen/Localize';
import { NavStyles } from './NavigationStyles';
import { NavListItemState } from './NavList';
import { NavPanelDisplayMode } from './NavPanel';


export interface NavListLinkProps extends NavListItemState {
  /** The url to navigate to when clicking this link */
  readonly href: string;
  /** The icon library function */
  iconType: (props: any) => React.ReactSVGElement | null;
  /** Localized text for this link */
  readonly name: string;
  /** Display mode for this link */
  readonly navPanelDisplayMode: NavPanelDisplayMode;
  /** Test Id for this link */
  readonly testId: string;
}

export class NavListLink extends React.PureComponent<NavListLinkProps, {}> {

  public render(): JSX.Element {
    const anchorClassName = NavStyles.NavLinkValue(this.props.selected);
    const disabledBarClassName = NavStyles.DisabledBarStyle(this.props.selected);
    const iconClassName = classes('icon', this.props.navPanelDisplayMode === 'icon' ? NavStyles.NavIcon : NavStyles.NavIconByText);
    const textClassName = classes('text', NavStyles.NavLinkText);
    forceRenderStyles(); // flush the styles above to DOM right away to ensure correct height measurement in LeftNav::updateVerticalScrollState

    const anchor = (
      <a
        href={this.props.href}
        tabIndex={this.props.tabbable ? 0 : -1}
        className={anchorClassName}
        data-tb-test-id={this.props.testId}
        aria-label={this.props.name}
      >
        {this.props.selected &&
          <div data-tb-test-id='selected-bar' style={NavStyles.SelectedBarStyle}/>}
        {
          <span className={iconClassName}>
            {this.props.iconType && this.props.iconType({size: NavStyles.navLinkIconSize})}
          </span>
        }
        {this.props.navPanelDisplayMode === 'iconAndText' &&
          <div className={textClassName}>{this.props.name}</div>
        }
      </a>
    );

    if (this.props.name === Messages.labels() && showDMAwareness(true)){
      return (
      <div data-tb-test-id='disabled-labels-bar' className={disabledBarClassName}>
        <Tooltip
          tooltipContent={<span>{Messages.dataManagementAwarenessLabelManagementTooltipHover()}</span>}
          position={TooltipPosition.Right}
          testId={this.props.testId+'-tooltip'}>
          {anchor}
        </Tooltip>
      </div>);
    }

    return this.props.navPanelDisplayMode === 'icon'
      ? <Tooltip getContent={() => <span>{this.props.name}</span>} position={TooltipPosition.Right} testId={this.props.testId+'-tooltip'}>
          {anchor}
        </Tooltip>
      : anchor;
  }
}
